import { ComponentRef, ViewContainerRef } from "@angular/core";
import { DrsDenyComponent } from "./drs-deny.component";


class DrsDenyForm implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;
    correlationId: string;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    viewContainerRef: ViewContainerRef;
    drsDenyComponentRef: ComponentRef<DrsDenyComponent>;

    constructor(formId: string, payload: object) {
        this.formId = formId;
        this.payload = payload;
        this.correlationId = payload['correlation_id'];
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {
      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        this.viewContainerRef.clear();
        this.drsDenyComponentRef = this.viewContainerRef.createComponent(DrsDenyComponent);
        this.drsDenyComponentRef.instance.onCloseLinkSubmit = this.onCloseSubmit.bind(this);
        this.drsDenyComponentRef.instance.correlationId = this.correlationId;

        return new Promise((resolve, reject) => {
          this.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({}));
              this.submitBlock = null;
            } catch (e) {
              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {
      }

      onError(payload: object): void {
      }

      private onCloseSubmit() {
        this.returnToClientApplicationWithError("access_denied","access_denied")
      }

      returnToClientApplicationWithError(error, errorDescription) {
        const url = this.clientContext['cookieService'].get('redirect_uri');

        let state = this.clientContext['cookieService'].get('state');
        let appendChar = '?';
        if (url.includes('?'))
        {
          appendChar = '&';
        }
        window.location.href = url + appendChar + 'error=' + error
          + '&error_description=' +  errorDescription
          + '&lang=' + this.clientContext['cookieService'].get('lang')
          + '&state=' + state;
        return;

  }
}

export default DrsDenyForm;
